import React, {useState, useEffect, useSearchParams} from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";

import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@material-ui/core";
import LoadingButton from '@mui/lab/LoadingButton';

import AddFeatureRow from "../../components/AddFeatureRow"
import { getAllSites, getBuildingsForSite, getBuildingSpaces, addFeature, getSpaceFeatures } from "../../services/MetadataService";
import { getFeatureTypes } from "../../services/DimensionsServices";

const AddFeatureForm = (props) => {
    let [sites, setSites] = useState()
    let [buildings, setBuildings] = useState([])
    let [spaces, setSpaces] = useState([])
    let [zones, setZones] = useState([])
    let [existingFeatures, setExistingFeatures] = useState([])

    let [selectedSite, setSelectedSite] = useState()
    let [selectedBuilding, setSelectedBuilding] = useState()
    let [selectedSpace, setSelectedSpace] = useState()
    let [selectedZone, setSelectedZone] = useState()

    let [featureTypes, setFeatureTypes] = useState([])

    let [rows, setRows] = useState(1)
    let [features, setFeatures] = useState({})
    let [successCount, setSuccessCount] = useState(0)
    let [isSubmitting, setIsSubmitting] = useState(false)
    let history = useHistory();

    useEffect(() => {
        if (featureTypes.length == 0) {
            getFeatureTypes().then(response => {
                setFeatureTypes(response)
            });
        }

        let spaceId = props.spaceId || (selectedSpace && selectedSpace.id)
        if (spaceId) {
            getSpaceFeatures(spaceId).then(response => {
                setExistingFeatures(response)
            })
        }

        if (!sites) {
            getAllSites(false).then(response => {
                response.sort((a, b) => (a.name > b.name) ? 1 : -1)
                setSites(response)
                if (props.siteId) {
                    let site = response.find(s => s.site_id == parseInt(props.siteId))
                    setSelectedSite(site)
                }
            })
        }
    },[])

    useEffect(() => {
        if (selectedSite) {
            getBuildingsForSite(selectedSite.site_id).then(response => {
                response.sort((a, b) => (a.name > b.name) ? 1 : -1)
                setBuildings(response)
                if (props.buildingId) {
                    let building = response.find(b => b.id == parseInt(props.buildingId))
                    setSelectedBuilding(building)
                }
            })
        }

    },[selectedSite])

    useEffect(() => {
        if (selectedBuilding) {
            getBuildingSpaces(selectedBuilding.id).then(response => {
                response.sort((a, b) => (a.name > b.name) ? 1 : -1)
                setSpaces(response)

                if (props.spaceId) {
                    let space = response.find(s => s.id == parseInt(props.spaceId))
                    setSelectedSpace(space)
                }
            })
        }

    },[selectedBuilding])


    const featureToAddCallback = (id, newFeature) => {
        let currentFeatures = Object.assign({}, features)
        if (newFeature.success) return;

        newFeature.success = null
        newFeature.error = null

        let existingFeature = existingFeatures && existingFeatures.find(s => s.name === newFeature.name)
        if (existingFeature) newFeature.error = "A feature with this name already exists for the current space."

        let addingFeature = Object.keys(features).find(index => index != id && features[index].name === newFeature.name)
        if (addingFeature) newFeature.error = "You have already added this feature."


        currentFeatures[id] = newFeature;
        setFeatures(currentFeatures)
    }

    const submitAll = () => {
        let currentFeatures = Object.assign({}, features)
        setIsSubmitting(true);

        Object.keys(features).forEach(i => {
            let f = features[i]
            setIsSubmitting(true);
            if (f.name && f.feature_type) {
                addFeature(f).then(response => {
                    currentFeatures[i].success = true
                    currentFeatures[i].error = null
                    setSuccessCount(successCount + 1)
                    setFeatures(currentFeatures)
                }).catch(err => {
                    currentFeatures[i].success = false
                    currentFeatures[i].error = "Failed to add feature"
                    setFeatures(currentFeatures)
                }).finally(() => {
                    setIsSubmitting(false);
                })
            }

        })

    }

    if (!sites) return null;

    let addRows = [];
    if (selectedSite && selectedBuilding && selectedSpace) {
        for (let i = 0; i < rows; i++) {
            let lastFeature =  (i > 0) ? features[i-1] : null;
            let rowFeature = features && features[i] || {
                space_id: selectedSpace.id,
                feature_type: lastFeature && lastFeature.feature_type
            };
            let key = "space_" + selectedSpace.id + "_" + i
            addRows.push(
                <AddFeatureRow key={key} row_num={i} callback={featureToAddCallback} featureTypes={featureTypes} feature={rowFeature} />
            )
        }
    }

    if (successCount === rows && rows != 0) {
        history.push("/spaces/" + selectedSpace.id)
    }

    let location = selectedSpace && selectedSpace.name ? "the space " + selectedSpace.name : null

    return (
        <div className="layer3">
            <div className="bulk-add-form">
                <div className="form-field">
                    <Autocomplete
                        disablePortal
                        id="sites"
                        options={sites}
                        getOptionLabel={option => option.name}
                        value={sites.find(s => s.site_id == props.siteId)}
                        renderInput={(params) => <TextField {...params} label="Site" variant="outlined" fullWidth size="small" />}
                        onChange={(event, newValue) => {
                            setSelectedSite(newValue);
                        }}
                    />
                </div>


            {
                buildings && buildings.length > 0 ?
                <div className="form-field">
                    <Autocomplete
                        disablePortal
                        id="buildings"
                        options={buildings}
                        getOptionLabel={option => option.name}
                        value={buildings.find(b => b.id == props.buildingId)}
                        renderInput={(params) => <TextField {...params} label="Building" variant="outlined" fullWidth size="small" />}
                        onChange={(event, newValue) => {
                            setSelectedBuilding(newValue);
                        }}
                    />
                </div> : null
            }

            {
                spaces && spaces.length > 0 ?
                <div className="form-field">
                    <Autocomplete
                        disablePortal
                        id="spaces"
                        options={spaces}
                        value={spaces.find(s => s.id == props.spaceId)}
                        getOptionLabel={option => option.name}
                        renderInput={(params) => <TextField {...params} label="Space" variant="outlined" fullWidth size="small" />}
                        onChange={(event, newValue) => {
                            setSelectedSpace(newValue);
                        }}
                    />
                </div> : null
            }

            {
                selectedSpace ?
                <div className="add-container">
                    <div className="instructions">Enter features for {location}:</div>
                    {
                        addRows
                    }

                    <div className="form-buttons">
                        <div className="form-button-left" onClick={() => {setRows(rows+1)}}>Add Row</div>
                        <div className="form-button-container-right">
                            <LoadingButton variant="contained" loading={isSubmitting} type="submit" onClick={submitAll}  style={{backgroundColor: "#003e51"}}>
                                Submit
                            </LoadingButton>
                        </div>
                    </div>
                </div> : null
            }

            </div>
        </div>

    )


}

export default AddFeatureForm;